import { render, staticRenderFns } from "./collectionsEdit.vue?vue&type=template&id=cad2f712&scoped=true&"
import script from "./collectionsEdit.vue?vue&type=script&lang=js&"
export * from "./collectionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad2f712",
  null
  
)

export default component.exports